/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_custom.js                                                                            */
/**********************************************************************************************************************/
/* Controller.Custom */
HafasWebapp.prototype.Controller.Custom = {
  Method: function (data) {
    console.log("This is an example for a custom Action!!!");
  }
};
